import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import SideBarSkeleton from '../../Component/SideBarSkeleton';
import Documents from './Documents';
import NotesList from './NotesList';
import AdminDocuments from './AdminDocuments';
import classes from './Documents.module.css';

const DocumentContainer = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const tabs = ['documents', 'notes'];

  const [tabValue, setTabValue] = useState(
    tab && tabs.includes(tab) ? tab : tabs[0],
  );

  const [showAdminDocs, setShowAdminDocs] = useState(false);

  const onTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue !== 'documents') {
      setShowAdminDocs(false);
    }
  };

  return (
    <SideBarSkeleton>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={onTabChange} aria-label="Documents Tab">
              {tabs.map((tab) => (
                <Tab key={tab} label={tab} value={tab} />
              ))}
            </TabList>
          </Box>
          <TabPanel value={tabs[0]} style={{ padding: '0 0 0 10px' }}>
            <div className={classes.container}>
              {!showAdminDocs ? (
                <Documents onSelect={() => setShowAdminDocs(true)} />
              ) : (
                <AdminDocuments onBack={() => setShowAdminDocs(false)} />
              )}
            </div>
          </TabPanel>
          <TabPanel value={tabs[1]} style={{ padding: '0 0 0 10px' }}>
            <div className={classes.container}>
              <NotesList />
            </div>
          </TabPanel>
        </TabContext>
      </Box>
    </SideBarSkeleton>
  );
};

export default DocumentContainer;
